export default {
  data() {
    return {
      rules: {
        required: (label) => (value) => !!`${value}`.trim() || `${label} é obrigatório`,
      },
    }
  },
}